<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-currency"></i> Solicitar Referencia Crediticia
      <div class="card-header-actions btn-group" dropdown placement="bottom left"></div>
    </div>

    <div class="card-body">
      <pos-stepper #cdkStepper linear="true" (selectionChange)="changeStep($event)">
        <cdk-step label="Factura" [stepControl]="invoiceForm">
          <invoice-details-step [invoice]="this.invoice"
            (doPayment)="buildPaymentsRequest($event)"></invoice-details-step>
        </cdk-step>
        <cdk-step label="Pago">
          <pay-invoice-step [paymentRequest]="paymentRequest" [order]="simulatedOrder"
            (doPay)="pay($event)"></pay-invoice-step>
        </cdk-step>
      </pos-stepper>
    </div>
  </div>
</div>